import React from 'react';

interface IProps {
	children: React.ReactNode;
}

export const FormSideTabs: React.FC<IProps> = ({ children }) => (
	<div className="w-55 shrink-0 flex flex-col gap-4" data-test="FormSideTabs">
		{children}
	</div>
);
